import { useMutation } from '@tanstack/react-query';

import { InspectionEntity } from '../entities/InspectionEntity';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig } from '@/lib/react-query';

export const createInspection =
  (makeRequest: any) =>
  async ({ shipmentId }: { shipmentId: string }): Promise<InspectionEntity> => {
    const { error, data } = await makeRequest({
      path: `/inspection/tickets`,
      method: 'post',
      body: { shipment_id: shipmentId },
    });
    if (error) {
      throw error;
    }

    return InspectionEntity.create(data);
  };

type UseCreateInspectionOptions = {
  config?: MutationConfig<ReturnType<typeof createInspection>>;
};

export const useCreateInspection = ({ config }: UseCreateInspectionOptions) => {
  const [, makeRequest] = useImperativeRequestWrapper('shipmentV3');

  return useMutation({
    ...config,
    mutationFn: createInspection(makeRequest),
  });
};
